








































































































































































































































import { Component, Model, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import { GapFilter } from "@/store/modules/types";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPagination,
    BPopover,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("gaps", ["filter", "campaigns"]),
  },
})
export default class GapPager extends Vue {
  @Prop(Number) readonly pageLength!: Number;
  @Prop(Boolean) readonly rowsChecked!: Boolean;
  @Prop(Number) readonly rowsTotal!: Number;
  @Prop(Number) readonly patientsTotal!: Number;
  filter!: GapFilter;
  campaignId = "";
  filterId = -1;
  filters = Array<any>();
  showSaveFilter = false;
  newFilterName = "";
  get selectedFilter() {
    return this.filters.find((f) => f.id === this.filterId);
  }
  campaignChanged() {
    this.$store.commit("gaps/SET_CAMPAIGN_FILTER", this.campaignId);
  }
  @Watch("filterId")
  filterChanged() {
    if (this.selectedFilter) {
      const filter = JSON.parse(this.selectedFilter.json) as GapFilter;
      if (!filter.entityId) {
        filter.entityId = this.filter.entityId;
      }
      this.campaignId = filter.campaignId;
      this.$store.commit("auth/SET_ENTITY", filter.entityId);
      this.$store.commit("gaps/SET_FILTER", filter);
    }
  }
  setPageNumber(page: number) {
    this.$store.commit("gaps/SET_PAGE_NUMBER", page);
  }
  setRowsPerPage(e) {
    const rowsPerPage: number = e.target.value;
    this.$store.commit("gaps/SET_ROWS_PER_PAGE", rowsPerPage);
  }
  async getFilters() {
    try {
      this.filters = await this.$store.dispatch("gaps/getFilters");
    } catch (error) {
      console.log(error);
    }
  }
  async saveFilter() {
    try {
      this.showSaveFilter = false;
      const { newFilterId } = await this.$store.dispatch(
        "gaps/saveFilter",
        this.newFilterName
      );
      this.filterId = newFilterId;
      this.newFilterName = "";
      this.getFilters();
    } catch (error) {
      console.log(error);
    }
  }
  async archiveFilter() {
    const { id, name } = this.selectedFilter;
    this.$modal.show("dialog", {
      title: "Remove filter '" + name + "'",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            try {
              await this.$store.dispatch("gaps/archiveFilter", id);
              this.$modal.hide("dialog");
              this.filterId = 0;
              this.getFilters();
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  clearFilter() {
    if (this.filterId === 0) {
      this.$store.commit("gaps/RESET_FILTER", this.filter.entityId);
    } /*else {
      this.filterId = 0;
    }*/

    this.filterId = -1;
    this.campaignId = "";
  }
  mounted() {
    this.campaignId = this.filter.campaignId;
    this.getFilters();
  }
}
